export class WebDevelopment {
  public webDevelopmentCarouselItems: Array<{ title: string; categories: Array<string>, active?: boolean }> = [
    {
      title: 'Web development',
      categories: [],
      active: true
    }, {
      title: 'Web design',
      categories: []
    }, {
      title: 'UX',
      categories: []
    }, {
      title: 'Interactive design',
      categories: []
    }, {
      title: 'Responsive development',
      categories: []
    }, {
      title: 'Analytics tool implementation',
      categories: []
    }, {
      title: 'Data visualization',
      categories: []
    }, {
      title: 'Hosting',
      categories: []
    }, {
      title: 'Website maintenance',
      categories: []
    }, {
      title: 'Landing page development',
      categories: []
    }, {
      title: 'HTML email builds',
      categories: []
    }
  ];
  
}